import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('category.code'),
	fieldsMap.get('category.description')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
